import { useQuery } from "react-query";

import { mlsSingleMatchStatsAPI } from "../../shared/api/variables";
import { useReactAppState } from "../../shared/containers/utils";
import { fetchClient } from "../../shared/api/fetching";

function useMLSMatch({ matchSportecId, options = {} }) {
    const { apiList } = useReactAppState();

    const mlsMatchEndpoint = mlsSingleMatchStatsAPI({ matchSportecId });

    return useQuery({
        queryKey: ["mls-match", matchSportecId],
        queryFn: () => fetchClient({ endpoint: mlsMatchEndpoint, apiURL: apiList?.statsAPI }),
        enabled: !!matchSportecId,
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity,
        ...options
    });
}

export default useMLSMatch;
